import React from 'react';
import { type IconType } from 'react-icons';

interface ManagerLinkCardProps {
  label: string;
  onClick: () => void;
  icon: IconType;
}

export const ManagerLinkCard = ({ label, onClick, icon }: ManagerLinkCardProps) => {
  const Icon = icon;

  return (
    <button
      onClick={onClick}
      className="
        flex flex-col items-center justify-center 
        p-4 h-32 bg-white rounded-lg shadow-md 
        border border-gray-200 text-gray-700 font-semibold 
        hover:bg-primary hover:text-white hover:shadow-xl 
        focus:outline-none focus:ring-2 focus:ring-primary-dark focus:ring-opacity-50
        transition-all duration-200 ease-in-out transform hover:-translate-y-1
      "
    >
      {/* Render the icon component and style it */}
      <Icon className="text-4xl mb-2" />
      <span className="text-center text-sm">{label}</span>
    </button>
  );
};